import { SingleMemberFirmCreationType } from '@bupa-kkv/features/company-creation/types';
import { companyCreationAxiosInstance } from '@bupa-monorepo/shared-frontend/admin/shared';

export const setShowEstablishedMessage = async (
  showMessage: boolean,
  type: SingleMemberFirmCreationType
) =>
  (
    await companyCreationAxiosInstance.patch(
      `v1/customer/single-member-firm-creations/showEstablishedMessage/${showMessage}`,
      showMessage,
      {
        params: { type },
      }
    )
  ).data;
